import type { IconProps } from '../types/IconProps.ts';
export const Trash2: IconProps = {
    name: 'Trash2',
    children: [
        `<path d="M3 6h2m0 0h3M5 6v14c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V6m2 0h-2m0 0h-3M8 6V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2M8 6h8M10 11v6M14 11v6" />`,
    ]
};